import React, { memo, useCallback, useMemo } from 'react'

import { Icon, Button, CalendarToday } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { clearDatePublished } from 'Pods/SearchPage/Store/actions/datePublished'
import { DATE_PUBLISHED } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'
import I18n from 'Pods/Shared/I18n'

import DatePublishedContent from './DatePublishedContent'

const translate = (key) => I18n.t(key, { ns: 'rails' })

const prefixIcon = <Icon notSpaced svgComponent={CalendarToday} color="dark" size="small" />

function DatePublished() {
  const datePublished = useSearchPageStore(state => state.datePublished ?? DATE_PUBLISHED.ALL_TIME)

  const hasSelectedAnyFilter = datePublished !== DATE_PUBLISHED.ALL_TIME

  const handleReset = useCallback(() => {
    clearDatePublished()
  }, [])

  const content = useMemo(() => (
    <>
      <DatePublishedContent />
      <Button
        type="ghost"
        size="tiny"
        customClass="filter-wrapper__reset-button"
        onClick={handleReset}
        disabled={!hasSelectedAnyFilter}
      >
        {translate('search_page.filters.more_filters.reset')}
      </Button>
    </>
  ), [handleReset, hasSelectedAnyFilter])

  return (
    <FiltersWrapper
      placeholder={translate('search_page.filters.date_published.title')}
      prefixIcon={prefixIcon}
      content={content}
      hasSelectedAnyFilters={hasSelectedAnyFilter}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(DatePublished)
